import { Injectable } from '@angular/core';

import { ConfigService } from 'src/app/core/core-config.service';
import { RequestService } from 'src/app/core/services/request.service';

import { SimpleSearch } from 'src/app/core/models/simple-search.model';
import { UserResponse } from '../models/user.model';
import { ClientResponse } from '../models/client.model';
import { IdentityResourceResponse } from '../models/identity-resource.model';
import { ApiResourceResponse } from '../models/api-resource.model';
import { CreateUser } from '../models/create-user.model';
import { CreateSiteInfoApiClientRequest } from '../models/create-siteinfo-api-client.model';



@Injectable()
export class UserService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService) {
    }

    listUsers(search: SimpleSearch):
        Promise<UserResponse> {

        let params = search.ToSearchParameters();

        let url =
            `${this.configService.config.apiBasePath}/userManagement/listUsers?${params.toString()}`;

        return this.requestService.get<UserResponse>(url);
    }

    createUser(createUser: CreateUser): Promise<any> {

        let url =
            `${this.configService.config.apiBasePath}/userManagement/createUser`;

        return this.requestService.post<any>(url, createUser);
    }

    makeAdmin(userEmail: string): Promise<any> {

        let url =
            `${this.configService.config.apiBasePath}/userManagement/makeAdmin`;

        return this.requestService.post<any>(url, { email: userEmail });
    }


    deleteUser(userEmail: string): Promise<any> {

        let url =
            `${this.configService.config.apiBasePath}/userManagement/deleteUser`;

        return this.requestService.post(url, { email: userEmail });
    }

    listIdentityResources(search: SimpleSearch):
        Promise<IdentityResourceResponse> {

        let params = search.ToSearchParameters();

        let url =
            `${this.configService.config.apiBasePath}/userManagement/ListIdentityResources?${params.toString()}`;

        return this.requestService.get<IdentityResourceResponse>(url);
    }

    listApiResources(search: SimpleSearch):
        Promise<ApiResourceResponse> {

        let params = search.ToSearchParameters();

        let url =
            `${this.configService.config.apiBasePath}/userManagement/listResources?${params.toString()}`;

        return this.requestService.get<ApiResourceResponse>(url);
    }

    changePassword(userEmail: string, newPassword: string): Promise<any> {
        const url = `${this.configService.config.apiBasePath}/userManagement/changePassword`;

        const payload = {
            email: userEmail,
            newPassword: newPassword
        };

        return this.requestService.post<any>(url, payload);
    }


}
